import React from 'react';
import { Paper, Theme, makeStyles, useTheme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  cardSheet: {
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #DAD9DF',
    borderRadius: '8px',
    height: 'fit-content'
  }
}));

interface CardSheetProps {
  maxWidth?: string,
  padding? :string
}

const CardSheet: React.FC<CardSheetProps> = ({ children, maxWidth, padding }) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  return (
    <Paper className={classes.cardSheet} style={{ maxWidth, padding }}>
      {children}
    </Paper>
  );
};

export default CardSheet;
